module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/solution1_1@2x-8b5ebe48df1733ab57476b6371840ec3.png";